import { EQuestionCodes } from '../../types/requestForm';
import { OfferComplaintTopBannerContainer, OfferComplaintBottomBannerContainer, PndBannerContainer, EmployeeBannerContainer, OfferComplaintFinaleTopBannerContainer, XmlUnloadingBannerContainer, VillageAddingTopBannerContainer } from '../../containers/banners';
export var addInfoBanner = function addInfoBanner(type) {
  switch (type) {
    case EQuestionCodes.ComplaintFromOwnerProperty:
      return [{
        component: PndBannerContainer,
        type: 'bottom'
      }];
    case EQuestionCodes.ChangedPhoneEmployeeFinal:
      return [{
        component: EmployeeBannerContainer,
        type: 'bottom'
      }];
    case EQuestionCodes.OfferComplaintInitial:
      return [{
        component: OfferComplaintBottomBannerContainer,
        type: 'bottom'
      }, {
        component: OfferComplaintTopBannerContainer,
        type: 'top'
      }];
    case EQuestionCodes.OfferComplaintFinal:
      return [{
        component: OfferComplaintFinaleTopBannerContainer,
        type: 'top'
      }];
    case EQuestionCodes.XmlUnloading:
      return [{
        component: XmlUnloadingBannerContainer,
        type: 'top'
      }];
    case EQuestionCodes.VillageAdding:
      return [{
        component: VillageAddingTopBannerContainer,
        type: 'top'
      }];
    default:
      return [];
  }
};